import React from 'react';
import { ToolbarRadio } from '../toolbar';
import type { EditorMode } from '../../hooks/useJsonGuiToggle';

interface EditorModeToggleProps {
  mode: EditorMode;
  onChange: (mode: EditorMode) => void;
}

/**
 * GUI / JSON switch for the catalog editor admin pages. GUI-vs-JSON is a
 * single-select "pick one" choice, so it's a `ToolbarRadio` group (shared
 * `name`) rather than chip toggles — see the `sm4rt-web-ui` skill §12. Lives
 * inside a `SecondaryToolbar floating` and matches the card-on-grey admin chrome.
 */
export const EditorModeToggle: React.FC<EditorModeToggleProps> = ({ mode, onChange }) => (
  <>
    <ToolbarRadio
      label="GUI"
      name="editor-mode"
      active={mode === 'gui'}
      onClick={() => mode !== 'gui' && onChange('gui')}
    />
    <ToolbarRadio
      label="JSON"
      name="editor-mode"
      active={mode === 'json'}
      onClick={() => mode !== 'json' && onChange('json')}
    />
  </>
);
